export default "__VITE_ASSET__C6XKmBUX__"